import React from "react";
import "./Post.css";
import { Button, Avatar } from "@material-ui/core";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import RepeatIcon from "@material-ui/icons/Repeat";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import PublishIcon from "@material-ui/icons/Publish";
function Post({ displayname, username, verified, text, image, avatar }) {
  return (
    <div className="post">
      <div className="postavatar">
        <Avatar src={avatar} />
      </div>
      <div className="post_body">
        <div className="post_header">
          <div className="post_header_text">
            <h4>
              {displayname}
              <span className="post__headerSpecial">
  {verified && <VerifiedUserIcon className="post_badge" /> }@
                  {username}
              </span>
            </h4>
            <div>
  <p>{text}</p>
            </div>
          </div>
          <img src={image} className="qq"/>
        </div>
        <div className="post__footer">
            <ChatBubbleOutlineIcon fontSize="small" />
            <RepeatIcon fontSize="small" />
            <FavoriteBorderIcon fontSize="small" />
            <PublishIcon fontSize="small" />
          </div>
      </div>
    </div>
  );
}

export default Post;
